import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function NotificationIcon({ className }: IconProps) {
  return (
    <svg
      width="60"
      height="77"
      viewBox="0 0 60 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1371)">
        <path
          d="M41.613 65.368C41.613 71.8042 36.4027 76.9999 30.0008 76.9999C23.599 76.9999 18.3887 71.7808 18.3887 65.368C18.3887 58.9552 23.599 53.7361 30.0008 53.7361C36.4027 53.7361 41.613 58.9552 41.613 65.368Z"
          fill="#00C4B3"
        />
        <path
          d="M45.724 19.6361C45.724 10.9531 38.6913 3.88501 29.9997 3.88501C21.3081 3.88501 14.2754 10.9297 14.2754 19.6361C14.2754 28.3425 21.3081 35.3871 29.9997 35.3871C38.6913 35.3871 45.724 28.3425 45.724 19.6361Z"
          fill="#00416B"
        />
        <path
          d="M53.7384 62.8637H6.26176C2.82718 62.8637 0.0234375 60.0786 0.0234375 56.6382V51.6765H59.9767V56.6382C59.9767 60.0786 57.173 62.8872 53.7384 62.8872"
          fill="#00416B"
        />
        <path
          d="M50.3738 29.8638C47.4533 27.1489 45.7243 23.4043 45.7243 19.4255V19.1681C45.7243 17.6936 44.5327 16.5 43.0607 16.5H16.9626C15.4907 16.5 14.2991 17.6936 14.2991 19.1681V19.4255C14.2991 23.4277 12.5234 27.1723 9.6028 29.9106C3.69159 35.3872 0 43.2043 0 51.8872C0 53.9234 0.21028 55.8894 0.584112 57.8085C1.16822 60.734 3.73832 62.8638 6.72897 62.8638H53.271C56.2149 62.8638 58.7617 60.8043 59.3692 57.9489C59.7196 56.3106 59.9299 54.6021 60 52.8702C60.3037 43.766 56.5187 35.5511 50.3972 29.8638"
          fill="#00416B"
        />
        <path
          d="M59.7904 58.3469C59.7904 63.1213 46.4493 66.983 30.0007 66.983C13.5521 66.983 0.210938 63.1213 0.210938 58.3469C0.210938 53.5724 13.5521 49.7107 30.0007 49.7107C46.4493 49.7107 59.7904 53.5724 59.7904 58.3469Z"
          fill="#00416B"
        />
        <path
          d="M34.8137 4.82128C34.8137 7.48936 32.6641 9.64255 30.0006 9.64255C27.337 9.64255 25.1875 7.48936 25.1875 4.82128C25.1875 2.15319 27.337 0 30.0006 0C32.6641 0 34.8137 2.15319 34.8137 4.82128Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1371">
          <rect width="60" height="77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
